import RpIcon from "@/components/RpIcon";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function AMLStatusHeader() {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);

  if (!user) return null;
  if (user.kycAmlReject != 1) return null;

  if (user.kycAmlDeclareSubmit == true) {
    return <Stack direction="column" justifyContent={"center"} alignItems={'center'} gap={2}>
      <RpIcon icon={'verifying'} size={56}/>
      <div className={'h2'}>{t('verifying')}</div>
    </Stack>
  }

  const icon = user.kycAmlDeclareSubmit == true ? 'verifying' : 'info';
  const title = user.kycAmlDeclareSubmit == true ? t('verifying') : t('additional_info_request');

  return (
    <Stack direction="column" justifyContent={"center"} alignItems={'center'} gap={2}>
      <RpIcon icon={icon} size={56}/>
      <Box className={'h2'}>{title}</Box>
    </Stack>
  );
}
